export enum TransferDirection {
  fromPrimary = 'fromPrimaryToSecondary',
  fromSecondary = 'fromSecondaryToPrimary',
}
